import type { GetCardsInput, GetCardsPayload } from 'CDK_API';
import { cardService } from './card.service';

export const getCardById = async (variables: GetCardsInput) => {
  const result = await cardService.getCards({ input: variables });
  // Return the API GetCardsPayload type so job-code consumers stay unchanged; the CDK payload
  // is the same entity minus __typename (runtime data is complete). Bridge at this boundary.
  return result?.items?.at(0) as unknown as GetCardsPayload | undefined;
};
